import Article from './Article';
import ArticleOption from './ArticleOption';

export default class ArticleGroup {
	id: string;
	quantity: number;
	note: string;
	article: Article;
	groups: ArticleOption[] = [];
	isPromo = false;
	freeArticle = false;
	references: string;
	isRecommendedRecipe = false;
	totalPrice: string = '';
	isHalfPizza: boolean = false;
	// Set by OrderUtils.injectDepositArticles on deposit lines it manages itself, so
	// they can be recomputed from scratch on every order update.
	isInjectedDeposit: boolean = false;
	// Deposit amount per single unit of this line that is charged through an injected
	// deposit article on top of the line's net price. Display only — the article
	// price served by the backend already excludes the deposit.
	injectedDepositPerUnit: number = 0;
}
